import {useFilterByLicense} from '@/biz/license.jsx'
import {useFilterByPlatformAdmin} from '@/biz/platformAdmin.jsx'

export default () => {
    const filterByLicense = useFilterByLicense()
    const filterByPlatformAdmin = useFilterByPlatformAdmin()

    return filterByLicense('M00010003', {
        title: '团队管理',

        children: [
            filterByPlatformAdmin({
                title: '个人号',
                to: ['/UserList'],
            }),

            {
                title: '团队号',
                to: ['/TeamList'],
            },

            {
                title: '团队库',

                children: [
                    {
                        title: '资源',
                        to: ['/TeamBctList'],
                    },
                    {
                        title: '界面视图模板',
                        to: ['/TeamUvTemplateList'],
                    },
                    {
                        title: '提示词模板',
                        to: ['/TeamPromptTemplateList'],
                    },
                ],
            },
        ],
    })
}
